export const menuList = [
  { name: '에듀케이션', id: 'edu' },
  { name: '비즈니스', id: 'biz' },
]
